import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__ from "@radix-ui/react-slot";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const buttonVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("tw-inline-flex tw-items-center tw-justify-center tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50", {
    variants: {
        variant: {
            default: "tw-bg-primary tw-text-primary-foreground tw-shadow hover:tw-bg-primary/90",
            destructive: "tw-bg-destructive tw-text-destructive-foreground tw-shadow-sm hover:tw-bg-destructive/90",
            outline: "tw-border tw-border-input tw-bg-white tw-shadow-sm hover:tw-bg-accent hover:tw-text-accent-foreground",
            secondary: "tw-bg-white tw-text-secondary-foreground tw-shadow-sm hover:tw-bg-accent hover:tw-text-accent-foreground",
            dark: "tw-bg-neutral-700 tw-text-primary-foreground tw-shadow-sm hover:tw-bg-neutral-600",
            ghost: "hover:tw-bg-accent hover:tw-text-accent-foreground",
            link: "tw-text-primary tw-underline-offset-4 hover:tw-underline"
        },
        size: {
            default: "tw-h-9 tw-px-3 tw-py-1",
            sm: "tw-h-8 tw-px-3 tw-text-xs",
            lg: "tw-h-10 tw-px-8",
            icon: "tw-h-9 tw-w-9"
        },
        rounded: {
            true: "tw-rounded-full",
            false: "tw-rounded-md"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default",
        rounded: false
    }
});
const LoadingSpinner = ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        className: "tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Loader2, {
            className: "tw-animate-spin"
        })
    });
const buttonTextStyles = "tw-whitespace-nowrap tw-text-sm tw-font-medium";
const Button = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, variant, size, rounded, isSubmitting, disabled, asChild = false, innerClassName, children, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("button", {
        disabled: isSubmitting || disabled,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-relative", buttonVariants({
            variant,
            size,
            rounded,
            className
        })),
        ref: ref,
        ...props,
        children: [
            isSubmitting && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LoadingSpinner, {}),
            asChild ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot, {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-inline-flex tw-items-center tw-justify-center tw-w-full", isSubmitting && "tw-invisible", buttonTextStyles, innerClassName),
                children: children
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-inline-flex tw-items-center tw-justify-center tw-w-full", isSubmitting && "tw-invisible", buttonTextStyles, innerClassName),
                children: children
            })
        ]
    }));
Button.displayName = "Button";
export { Button, buttonVariants };

//# sourceMappingURL=button.mjs.map